<script setup lang="ts">

</script>

<template>
  <div class="flex flex-row">
    <slot/>
  </div>
</template>

<style scoped>

</style>
